import { Finding } from '@consigli/types';

/**
 * Component to render the expanded content for a finding in the findings table.
 * Displays detailed information about the finding including content, reference content,
 * message template, reference file, and message context.
 * @param finding - The finding object to display content for
 * @returns JSX element containing the expanded finding content
 */
export const FindingContent = ({ finding }: { finding: Finding }) => {
  return (
    <div className="space-y-4">
      <div>
        <h4 className="font-semibold text-sm text-gray-900 mb-2">Content</h4>
        <div className="bg-white p-3 rounded border text-sm text-gray-700 whitespace-pre-wrap break-words">
          {finding.content || 'No content available'}
        </div>
      </div>

      {finding.refContent && (
        <div>
          <h4 className="font-semibold text-sm text-gray-900 mb-2">Reference Content</h4>
          <div className="bg-white p-3 rounded border text-sm text-gray-700 whitespace-pre-wrap break-words">
            {finding.refContent}
          </div>
        </div>
      )}

      <div className="grid grid-cols-2 gap-4">
        <div>
          <h4 className="font-semibold text-sm text-gray-900 mb-1">Message Template</h4>
          <p className="text-sm text-gray-600">{finding.messageTemplate}</p>
        </div>
        <div>
          <h4 className="font-semibold text-sm text-gray-900 mb-1">Reference File</h4>
          <p className="text-sm text-gray-600">{finding.refFileName || 'N/A'}</p>
        </div>
      </div>

      {finding.messageContext && Object.keys(finding.messageContext).length > 0 && (
        <div>
          <h4 className="font-semibold text-sm text-gray-900 mb-2">Message Context</h4>
          <div className="bg-gray-100 p-3 rounded text-sm">
            <pre className="whitespace-pre-wrap break-words">
              {JSON.stringify(finding.messageContext, null, 2)}
            </pre>
          </div>
        </div>
      )}
    </div>
  );
};
